export const SEND_UPDATED_STATS = 'SEND_UPDATED_STATS';
